import React from 'react';
import Collapse from '@mui/material/Collapse';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Icon from '@mui/material/Icon';
import { MDBox } from '../../MDBox';
import {
  collapseItem,
  collapseIconBox,
  collapseIcon,
  collapseText,
  collapseArrow,
} from './styles/sidenavCollapse';
import { useMaterialUIController } from '../../../contexts/layoutContext';
import { FFTheme } from '../../../assets/theme';
import { useTheme } from '@mui/material';

interface SidenavCollapseProps {
  icon: React.ReactNode;
  name: string | React.ReactNode;
  children?: React.ReactNode;
  active?: boolean;
  noCollapse?: boolean;
  open?: boolean;
  [key: string]: any;
}

function SidenavCollapse({
  icon,
  name,
  children,
  active = false,
  noCollapse = false,
  open = false,
  ...rest
}: SidenavCollapseProps) {
  const theme = useTheme<FFTheme>();
  const [controller] = useMaterialUIController();
  const { miniSidenav, transparentSidenav, whiteSidenav, darkMode } =
    controller;

  return (
    <>
      <ListItem component="li">
        <MDBox
          {...rest}
          sx={collapseItem(theme, {
            active,
            transparentSidenav,
            whiteSidenav,
            darkMode,
          })}
          style={{ margin: '0px 4px' }}
        >
          <ListItemIcon
            sx={collapseIconBox(theme, {
              transparentSidenav,
              whiteSidenav,
              darkMode,
              active,
            })}
            style={{ paddingRight: 10 }}
          >
            {typeof icon === 'string' ? (
              <Icon
                sx={collapseIcon(theme, {
                  transparentSidenav,
                  whiteSidenav,
                  darkMode,
                  active,
                })}
              >
                {icon}
              </Icon>
            ) : (
              icon
            )}
          </ListItemIcon>

          <ListItemText
            primary={name}
            sx={collapseText(theme, {
              miniSidenav,
              transparentSidenav,
              whiteSidenav,
              darkMode,
              active,
            })}
          />

          {/* <Icon
            sx={collapseArrow(theme, {
              noCollapse,
              transparentSidenav,
              whiteSidenav,
              miniSidenav,
              open,
              active,
              darkMode,
            })}
          >
            expand_less
          </Icon> */}
        </MDBox>
      </ListItem>
      {children && (
        <Collapse in={open} unmountOnExit>
          {children}
        </Collapse>
      )}
    </>
  );
}

export { SidenavCollapse };
